import { render, staticRenderFns } from "./CaseMedications.vue?vue&type=template&id=22e83cbb&scoped=true&"
import script from "./CaseMedications.vue?vue&type=script&lang=js&"
export * from "./CaseMedications.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedications.vue?vue&type=style&index=0&id=22e83cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e83cbb",
  null
  
)

export default component.exports